import { api, setConfig, UPDATE_GAME_CATEGORY_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const addNewGameCategory = (data: PropertyType): Promise<PropertyType> =>
	api.post('/games/categories/create', mapEntityToApi(data), setConfig(data)).then((res) => {
		return { message: UPDATE_GAME_CATEGORY_MESSAGE, gameCategory: res.data };
	});
